import { render } from "./WhatsAppBSPCallbackView.vue?vue&type=template&id=d55fc0d2&scoped=true"
import script from "./WhatsAppBSPCallbackView.vue?vue&type=script&lang=js"
export * from "./WhatsAppBSPCallbackView.vue?vue&type=script&lang=js"

import "./WhatsAppBSPCallbackView.vue?vue&type=style&index=0&id=d55fc0d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d55fc0d2"]])

export default __exports__